import { useState } from "react"
import { videos } from "../data/content"

export function GoVideoSection() {
  const [selectedKey, setSelectedKey] = useState(videos[0]?.key ?? "promo")
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768

  const selectedVideo = videos.find((v) => v.key === selectedKey) ?? videos[0]
  const src =
    isMobile && selectedVideo?.srcMobile
      ? selectedVideo.srcMobile
      : (selectedVideo?.src ?? "")

  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/message.svg" alt="" />
          </span>
          How it works
        </span>

        <h2 className="mk-title">
          See To To-Do <span className="mk-title-accent">in Action</span>
        </h2>
        <p className="mk-subtitle">
          Watch how To To-Do brings together everything you need for a life in
          sync. By extracting thoughts, tasks and ideas from your brain, you
          relieve the brain and get more focus, less stress and more motivation
          to actually do the tasks.
        </p>

        <div className="mk-video-toggle">
          {videos.map((v) => (
            <button
              key={v.key}
              className={selectedKey === v.key ? "active" : ""}
              onClick={() => setSelectedKey(v.key)}
            >
              {v.title}
            </button>
          ))}
        </div>

        <div className="mk-video-frame">
          <iframe
            src={src}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            title={selectedVideo?.title ?? "Video"}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}
